/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Label, MultipleSelect, SelectButton, Text } from "@nordcloud/gnui";
import { Fieldset } from "~/components/Forms";

type BillingGranularityProps = {
  setUnit: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  unit: string;
  canEdit?: boolean;
};

const billingUnits = [
  { name: "15", value: "15_MIN" },
  { name: "30", value: "30_MIN" },
  { name: "60", value: "60_MIN" },
];

type BillingUnit = {
  name: string;
  value: string;
};

function BillingGranularity({
  setUnit,
  name,
  unit,
  canEdit = true,
}: BillingGranularityProps) {
  function getReadValue(): string {
    // eslint-disable-next-line fp/no-loops
    for (const item of billingUnits) {
      if (unit === item.value) return item.name;
    }

    return " - ";
  }

  return (
    <Fieldset>
      <Label name="Billing Units - minutes" />
      {canEdit ? (
        <MultipleSelect size="small">
          {billingUnits?.map((item: BillingUnit) => {
            return (
              <SelectButton
                key={item.value}
                name={name}
                value={item.value}
                labelText={item.name}
                onClick={() => {
                  setUnit(item.value);
                }}
                isActive={unit === item.value && canEdit}
                data-cy={name + "-" + item.value}
              />
            );
          })}
        </MultipleSelect>
      ) : (
        <Text>{getReadValue()}</Text>
      )}
    </Fieldset>
  );
}

export { BillingGranularity };
